import { memo } from "react";
import { formatAmount } from "../utils/scoreFormatter";

/** Display names as on the reference label (codes come from the nutrition service). */
const NAMES = {
  thiamine: "Vitamin B1 (Thiamine)",
  riboflavin: "Vitamin B2 (Riboflavin)",
  niacin: "Vitamin B3 (Niacin)",
  folate: "Folate (B9)",
  pantothenicAcid: "Vitamin B5 (Pantothenic acid)",
  biotin: "Vitamin B7 (Biotin)",
};

/**
 * Vitamins then minerals per 100 g, as recorded by the nutrition team, each
 * with the % of the adult daily reference it covers.
 */
function VitaminsMinerals({ micronutrients }) {
  const items = [...(micronutrients ?? [])].sort(
    (a, b) => (a.group === b.group ? 0 : a.group === "VITAMIN" ? -1 : 1),
  );

  return (
    <div className="ep-facts-box">
      <h3>Vitamins &amp; Minerals</h3>
      {items.length === 0 ? (
        <p className="ep-fact-empty">Vitamin and mineral values are not available for this product yet.</p>
      ) : (
        items.map((m) => (
          <div key={m.code} className="ep-fact is-compact" title={`${m.rdaPct}% of daily needs`}>
            <span>{NAMES[m.code] ?? m.name}</span>
            <b>
              {formatAmount(m.amount, m.unit, 2)}{" "}
              <small style={{ color: "var(--ep-faint)", fontWeight: 400 }}>{Math.round(m.rdaPct)}%</small>
            </b>
          </div>
        ))
      )}
    </div>
  );
}

export default memo(VitaminsMinerals);
